import { render, staticRenderFns } from "./CommonFileLabels.vue?vue&type=template&id=003e894c"
import script from "./CommonFileLabels.vue?vue&type=script&lang=js"
export * from "./CommonFileLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports